import React, { useEffect } from "react";
import "../../styles/admins/dashboard.css";
import ReflectionCard from "../generals/reflection_card";
import {
  fetchFoodsData,
  fetchGuestData,
  fetchRoomsData,
} from "../confs/apis_at_once";

const addRooms = {
  business_name: "Add Room",
  address:
    "Keep your room inventories up-to-date for smooth working operations and better guest satisfaction.",
  name: "",
  contact: "",
  btnTitle: "+ Add Rooms",
  btnUrl: "/admin/add-room",
};

const addFoods = {
  business_name: "Add Food",
  address:
    "Keep your menu current and flexible, allowing seamless food management and improved dining experiences.",
  name: "",
  contact: "",
  btnTitle: "+ Add Foods",
  btnUrl: "/admin/add-food",
};

const advanceBooking = {
  business_name: "Advance Booking",
  address:
    "Enable guests to reserve rooms in advance, ensuring smooth planning and a better stay experience.",
  name: "",
  contact: "",
  btnTitle: "+ View Bookings",
  btnUrl: "/admin/advance-history",
};

const addStaff = {
  business_name: "Add Staff",
  address:
    "Maintain a well-organized staff directory, ensuring efficient operations and seamless service delivery to guests.",
  name: "",
  contact: "",
  btnTitle: "+ Add Staff",
  btnUrl: "/admin/add-staff",
};

function AdminDashboard({ clientDetails, handleToast }) {
  useEffect(() => {
    const loadDashboardData = async (id) => {
      try {
        // Fetch all data in parallel
        await Promise.all([
          fetchRoomsData(id),
          fetchFoodsData(id),
          fetchGuestData(id),
        ]);
      } catch (e) { }
    };

    // Check if data exists in localStorage to prevent re-fetching
    const storedData = localStorage.getItem("rooms");
    const storedFoods = localStorage.getItem("foods");
    const storedGuests = localStorage.getItem("guests");
    if (!storedData || !storedFoods || !storedGuests) {
      loadDashboardData(clientDetails.id);
    }
  }, [clientDetails.id]);

  const staffAs = localStorage.getItem("staff_as");
  const staffDetails = staffAs ? JSON.parse(staffAs) : null;

  const permissions = staffDetails?.permissions
    ? JSON.parse(staffDetails.permissions)
    : {};

const logo = clientDetails ? clientDetails.image : "https://images.unsplash.com/photo-1621075160523-b936ad96132a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" 
    
  return (
    <section className="row">

      {staffDetails === null &&
        <>
          <div className="col-lg-4 col-12">
            <ReflectionCard clientDetails={clientDetails} />
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <ReflectionCard clientDetails={addRooms} />
            <ReflectionCard clientDetails={addFoods} />
          </div>
          <div className="col-lg-4 col-md-6 col-12">
            <ReflectionCard clientDetails={advanceBooking} />
            <ReflectionCard clientDetails={addStaff} />
          </div>
        </>}


      {staffDetails != null &&
        <>
          <div className="col-lg-4 col-12">  
        <div className="nft">
            <div className='main'>
                {clientDetails.pass !== undefined && <img className='tokenImage' src={logo} alt="NFT" />}
                {clientDetails.pass !== undefined && <br />}
                <h2>{clientDetails.business_name === undefined ? "Title" : clientDetails.business_name}</h2>
                <p className='description'>{clientDetails.address === undefined ? "Address" : clientDetails.address}</p>
                <p className='description'>{clientDetails.name === undefined ? "Name" : clientDetails.name}</p>
                <div className='tokenInfo'>
                    <div className="price">
                        <p>{clientDetails.contact === undefined ? "No Contact" : clientDetails.contact}</p>
                    </div>
                    <div className="duration">
                        <p>{clientDetails.gstin === null ? "NO GSTIN" : clientDetails.gstin}</p>
                    </div>
                </div>
                <hr />
                <div className='creator'>
                    {clientDetails.hotel_id === undefined ? "" : <p><ins>Client ID </ins>  {clientDetails.hotel_id}</p>}
                </div>
                
                                <button className='card-btn text-light' onClick={() =>                handleToast({
        toastMsg: "You cannot edit these details. Please contact the admin.",
        toastColor: "#FF0000",
      })
} >Edit Details</button>
                
            </div>
        </div>      </div>
          {permissions.room &&
            <>
              <div className="col-lg-4 col-md-6 col-12">
                <ReflectionCard clientDetails={addRooms} />
                {permissions.food &&
                  <ReflectionCard clientDetails={addFoods} />
                }
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <ReflectionCard clientDetails={advanceBooking} />
                {/* <ReflectionCard clientDetails={addStaff} /> */}
              </div></>}
        </>}

    </section>
  );
}

export default AdminDashboard;
